import React from 'react'
import { Outlet } from 'react-router-dom';
import SideNave from '../../components/Admincomponents/SideNave/SideNave.jsx';

export default function AdminLayout() {
    return (
        <div className='flex justify-center items-center'>
            <div className="sidenav">
                <SideNave />
            </div>
            <div className="w-full overflow-hidden">
                <Outlet>
                </Outlet>
            </div>
        </div>
    )
}
